import {Layout} from '../../../layout'
import {useBasicTableContext} from '../../context'

export const BasicTableSectionHeader = () => {
	const {sectionHeader = {}} = useBasicTableContext()
	const {left, right} = sectionHeader

	if (!left && !right) return null

	return (
		<Layout horizontal="spaceBetween" minHeight={40} padding="12 - - -">
			<Layout>{left}</Layout>
			<Layout>{right}</Layout>
		</Layout>
	)
}
